import React, { Component } from 'react';
import AdvModal from '../common/AdvModal';
import * as utils from '../../shared/ClientUtils';
import * as ct from '../../shared/ClientConstants';
import MgalleryView from '../media/MgalleryView';
import IconTableHead from '../common/IconTableHead';
import PlayerId from '../common/PlayerId';
import ClubId from '../common/ClubId';
import AdvLoadingSymbol from '../common/AdvLoadingSymbol';
import AdvBasicTable from '../common/AdvBasicTable';
import StatusId from '../common/StatusId';
import Slider from 'react-slick';
import MatchBox from './MatchBox';
import VerticalPlayerId from '../common/VerticalPlayerId';
import TournamentBox from './TournamentBox';
import { GlobalContext } from '../shared/GlobalContext';
import { Tab, Row, Col, Nav } from 'react-bootstrap';
import AdvTippedText from '../common/AdvTippedText';
import NewsBox from './NewsBox';
import StatBox from './StatBox';
import VisitorStatBox from './VisitorStatBox';

const LIGHT_SHADING_COLOR = '#b8d3ff';
const COMMON_MARGIN = 5;

const SHADING_COLOR = '#68afff';

const CAROUSEL_SPEED_SEC = 6;
const MATCH_BOX_SIZE = 8;
const MATCH_BOX_PAGES = 3;

export class HomePage extends Component {
  static contextType = GlobalContext;

  state = {
    solutionModal: null,
    homeInfo: null,
    carouselGallery: null,
    //tabAutoPlay: true,
    //tabAutoIndex: 0,
    matchBoxPage: 0,
    matchBoxSize: MATCH_BOX_SIZE,
    matchBoxPageCount: MATCH_BOX_PAGES,
    galleryHeightTimer: null,
  };

  componentDidMount() {
    this.fetchCarouselGalleryId();
    this.fetchHomeInfo();

    /*
    this.tabTimer = setInterval(
      () =>
        this.state.tabAutoPlay &&
        this.setState({
          tabAutoIndex:
            this.state.tabAutoIndex === ALL_TABS.length - 1
              ? 0
              : this.state.tabAutoIndex + 1,
        }),
      1000 * TAB_SPEED_SEC
    );
    */
  }

  fetchCarouselGalleryId = () => {
    utils.quickGet(
      '/api/data/document/one?tag=homeCarouselGalleryId',
      {},
      utils.toastAlertFunc,
      'Error getting document for tag homeCarouselGalleryId: ',
      (j) => {
        if (
          j.document &&
          j.document.contents &&
          j.document.contents !== 'default'
        ) {
          utils.quickGet(
            '/api/data/mGallery/one?mGalleryId=' + j.document.contents,
            {},
            utils.toastAlertFunc,
            'Error getting gallery for home carousel: ',
            (j) => {
              this.setState({ carouselGallery: j.mGallery });
            }
          );
        }
      }
    );
  };

  fetchHomeInfo = () => {
    utils.quickGet(
      '/api/data/table/homeInfo',
      {},
      utils.toastAlertFunc,
      'Error retrieving home information from server: ',
      (j) => {
        this.setState({
          homeInfo: j.data,
          accessInfo: j.accessInfo,
          galleryHeightTimer: setInterval(this.computeMatchBoxParameters, 50),
        });
      }
    );
  };

  componentWillUnmount = () => {
    clearInterval(this.state.galleryHeightTimer);
  };

  computeMatchBoxParameters = () => {
    let matchBoxSize = MATCH_BOX_SIZE;
    let matchBoxPageCount = MATCH_BOX_PAGES;

    if (!this.galleryElement) return;

    const galleryHeight = this.galleryElement.clientHeight;

    if (galleryHeight != this.state.galleryHeight) {
      matchBoxSize = Math.floor((galleryHeight - 70) / 40);
      if (matchBoxSize > 12) {
        matchBoxSize = 12;
      }

      matchBoxPageCount = Math.floor(24 / matchBoxSize);

      this.setState({ matchBoxSize, matchBoxPageCount, galleryHeight });
    }
  };

  renderAreaTitle = ({ title, large, buttons }) => {
    return (
      <div className='row' style={{ paddingTop: '35px' }}>
        <div
          className={large ? 'col-2' : 'col-4'}
          style={{
            display: 'flex',
            justifyContent: 'right',
            alignItems: 'right',
          }}
        >
          {buttons && buttons.left}
        </div>
        <div
          className={large ? 'col-8' : 'col-4'}
          style={{
            paddingTop: '8px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
            backgroundColor: SHADING_COLOR,
          }}
        >
          <h4>{title}</h4>
        </div>
        <div className={large ? 'col-2' : 'col-4'}>
          {buttons && buttons.right}
        </div>
      </div>
    );
  };

  renderTopTitle = (title) => {
    return (
      <div className='row' style={{ paddingTop: '5px' }}>
        <div className='col-2'></div>
        <div
          className='col-8'
          style={{
            paddingTop: '8px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
            backgroundColor: LIGHT_SHADING_COLOR,
          }}
        >
          <h5>{title}</h5>
        </div>
        <div className='col-2'></div>
      </div>
    );
  };

  renderAreaContents = (contents, marginTop) => {
    return (
      <div className='row'>
        <div className='col-12'>
          <div
            className='card'
            style={{ borderWidth: 2, borderColor: SHADING_COLOR, marginTop }}
          >
            <div className='card-body' style={{ padding: 0 }}>
              {contents}
            </div>
          </div>
        </div>
      </div>
    );
  };

  renderCenteredRow = (contents, style) => {
    return (
      <div className='row' style={style}>
        <div
          className='col-12'
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
          }}
        >
          {contents}
        </div>
      </div>
    );
  };

  renderDate = (date) => {
    return this.renderCenteredRow(
      <h5
        style={{
          fontWeight: 'normal',
          fontStyle: 'italic',
        }}
      >
        {new Date(date).toLocaleDateString()}
      </h5>
    );
  };

  render() {
    return (
      <div className='card'>
        <AdvModal
          show={this.state.solutionModal}
          title='Solution'
          onClose={() => this.setState({ solutionModal: null })}
          body={this.state.solutionModal}
        />
        <div className='row'>
          <div className='col-12'>
            <img
              src={`/home/pro.png`}
              alt='pro'
              style={{
                width: '100%',
                margin: 0,
              }}
            />
          </div>
        </div>

        {!this.state.homeInfo ? (
          <AdvLoadingSymbol />
        ) : (
          <>
            <div className='row'>
              <div className='col-5' style={{ marginTop: 20 }}>
                <div
                  ref={(galleryElement) => {
                    this.galleryElement = galleryElement;
                  }}
                  style={{ padding: 15 }}
                >
                  <MgalleryView
                    autoplay={true}
                    autoplaySpeed={1000 * CAROUSEL_SPEED_SEC}
                    infinite={true}
                    slidesToShow={1}
                    pathPrefix={
                      this.state.carouselGallery
                        ? undefined
                        : '../../homeCarousel/'
                    }
                    imageHeight={200}
                    imageWidth={200}
                    gallery={
                      this.state.carouselGallery
                        ? {
                            ...this.state.carouselGallery,
                            name: null,
                            date: null,
                          }
                        : {
                            imageFilepaths: utils
                              .generateConsecutiveArray(7)
                              .map((n) => n + '.jpeg'),
                          }
                    }
                  />
                </div>
              </div>
              <div
                className='col-7'
                style={{
                  paddingLeft: 0,
                  paddingRight: 40,
                }}
              >
                <div>
                  {this.renderAreaTitle({
                    title: 'Matches',
                    buttons: {
                      right:
                        this.state.matchBoxPage <
                        this.state.matchBoxPageCount - 1 ? (
                          <button
                            className='btn btn-sm btn-primary'
                            style={{ height: '100%' }}
                            onClick={() =>
                              this.setState({
                                matchBoxPage: this.state.matchBoxPage + 1,
                              })
                            }
                          >
                            {'>'}
                          </button>
                        ) : undefined,
                      left:
                        this.state.matchBoxPage > 0 ? (
                          <button
                            className='btn btn-sm btn-primary'
                            style={{ height: '100%' }}
                            onClick={() => {
                              console.log(this.galleryElement.clientHeight);
                              this.setState({
                                matchBoxPage: this.state.matchBoxPage - 1,
                              });
                            }}
                          >
                            {'<'}
                          </button>
                        ) : undefined,
                    },
                  })}
                  <MatchBox
                    page={this.state.matchBoxPage}
                    size={this.state.matchBoxSize}
                    matches={this.state.homeInfo.scheduledMatches
                      .map((m) => ({
                        ...m,
                        unplayed: true,
                      }))
                      .concat(this.state.homeInfo.recentMatches)}
                  />
                </div>
              </div>
            </div>

            {/* Stats */}
            {this.renderAreaContents(
              <div className='row' style={{ padding: '7px' }}>
                {[
                  {
                    title: 'Players',
                    number: this.state.homeInfo.totalMemberCount,
                    iconName: 'participants',
                    delta: this.state.homeInfo.newMemberCount,
                    period: '30 days',
                  },
                  {
                    title: 'Tournaments',
                    number: this.state.homeInfo.completedTournamentCount,
                    iconName: 'trophy',
                    delta: this.state.homeInfo.recentTournamentCount,
                    period: '30 days',
                  },
                  {
                    title: 'Matches',
                    number: this.state.homeInfo.totalMatchCount,
                    iconName: 'matches',
                    delta: this.state.homeInfo.recentMatchCount,
                    period: '30 days',
                  },
                ].map((stat) => (
                  <div className='col-4' key={stat.title}>
                    <StatBox {...stat} />
                  </div>
                ))}
              </div>,
              10
            )}
            {/* End of Stats */}

            {/* Tournaments */}
            {this.renderAreaTitle({ title: 'Tournaments' })}
            <div
              className='row'
              style={{
                marginLeft: '10px',
                marginRight: '10px',
              }}
            >
              <div className='col-1'></div>
              <div className='col-10'>
                <AdvBasicTable
                  noHead
                  columns={[
                    {
                      key: 'uiStatus',
                      fixedWidth: '15%',
                    },

                    {
                      key: 'uiName',
                    },
                    {
                      key: 'uiDate',
                      fixedWidth: '15%',
                    },
                    {
                      key: 'uiMedium',
                      fixedWidth: '15%',
                    },

                    {
                      key: 'uiParticipation',
                      fixedWidth: '10%',
                    },
                  ]}
                  data={this.state.homeInfo.activeTournaments.map(
                    (tournament) => ({
                      ...tournament,
                      uiStatus: <StatusId status={tournament.status} />,
                      uiDate: new Date(tournament.startDate).toLocaleDateString(
                        undefined,
                        { day: 'numeric', month: 'short' }
                      ),
                      uiName: (
                        <a href={'/tournament/' + tournament._id}>
                          <h5 style={{ marginTop: 4 }}>{tournament.name}</h5>
                        </a>
                      ),
                      uiMedium: (
                        <div>
                          {tournament.medium === 'Live' ? (
                            <IconTableHead inTable name='live' tip='Live' />
                          ) : (
                            <IconTableHead inTable name='online' tip='Online' />
                          )}
                          {' ' + tournament.location}
                        </div>
                      ),
                      uiParticipation: (
                        <div>
                          {tournament.participantType === 'Individuals' ? (
                            <IconTableHead
                              inTable
                              name='member_name'
                              tip='Individuals'
                            />
                          ) : tournament.participantType === 'Teams' ? (
                            <IconTableHead inTable name='teams' tip='Teams' />
                          ) : tournament.participantType === 'Doubles' ? (
                            <IconTableHead
                              inTable
                              name='doubles'
                              tip='Doubles'
                            />
                          ) : (
                            <IconTableHead inTable name='club' tip='Clubs' />
                          )}
                          {' ' + tournament.participantCount}
                        </div>
                      ),
                    })
                  )}
                />
              </div>
              <div className='col-1'></div>
            </div>
            {/* End of Tournaments */}

            {/* Recent Trophys */}
            {this.renderAreaTitle({ title: 'Recent Trophys' })}
            {this.renderAreaContents(
              <div>
                <div className='row' style={{ margin: COMMON_MARGIN }}>
                  {utils.generateConsecutiveArray(4).map((n) => {
                    const t = this.state.homeInfo.completedTournaments[n - 1];
                    if (!t) return <div key={n} />;
                    return (
                      <div className='col-3' key={t._id}>
                        <div className='card'>
                          <div
                            className='card-body'
                            style={{
                              height: '60px',
                              padding: '10px',
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                              textAlign: 'center',
                              backgroundColor: LIGHT_SHADING_COLOR,
                            }}
                          >
                            {this.renderCenteredRow(
                              <a href={'/tournament/' + t._id}>{t.name}</a>
                            )}
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
                <div className='row' style={{ margin: COMMON_MARGIN }}>
                  {utils.generateConsecutiveArray(4).map((n) => {
                    const t = this.state.homeInfo.completedTournaments[n - 1];
                    if (!t) return <div key={n} />;
                    return (
                      <div className='col-3' key={t._id}>
                        <div
                          className='card'
                          style={{
                            borderWidth: 0,
                          }}
                        >
                          <div
                            className='card-body'
                            style={{
                              padding: '10px',
                            }}
                          >
                            {this.renderCenteredRow(
                              <div
                                style={{
                                  marginBottom: '5px',
                                  marginTop: '5px',
                                }}
                              >
                                {t.medium === 'Live' ? (
                                  <IconTableHead
                                    inTable
                                    name='live'
                                    tip='Live'
                                  />
                                ) : (
                                  <IconTableHead
                                    inTable
                                    name='online'
                                    tip='Online'
                                  />
                                )}
                                {' ' + t.location}
                              </div>
                            )}
                            {this.renderCenteredRow(
                              <div style={{ marginBottom: '5px' }}>
                                {t.participantType === 'Individuals' ? (
                                  <IconTableHead
                                    inTable
                                    name='member_name'
                                    tip='Individuals'
                                  />
                                ) : t.participantType === 'Teams' ? (
                                  <IconTableHead
                                    inTable
                                    name='teams'
                                    tip='Teams'
                                  />
                                ) : t.participantType === 'Doubles' ? (
                                  <IconTableHead
                                    inTable
                                    name='doubles'
                                    tip='Doubles'
                                  />
                                ) : (
                                  <IconTableHead
                                    inTable
                                    name='club'
                                    tip='Clubs'
                                  />
                                )}
                                {' ' + t.participantCount}
                              </div>
                            )}
                            {t.winner ||
                            (t.winners && t.winners.length === 1) ? (
                              <VerticalPlayerId
                                proCode={
                                  t.winnerProCode ||
                                  (t.winnersProCodes && t.winnersProCodes[0])
                                }
                                name={t.winner || (t.winners && t.winners[0])}
                                _id={
                                  t.winnerId ||
                                  (t.winnersIds && t.winnersIds[0])
                                }
                                limitWidth='60%'
                                limitMargin='20%'
                              />
                            ) : t.winners ? (
                              <div className='row' style={{ marginTop: 20 }}>
                                {t.winners.map((w, index) => (
                                  <div
                                    className={
                                      t.winners.length === 1
                                        ? 'col-12'
                                        : 'col-6'
                                    }
                                  >
                                    <VerticalPlayerId
                                      //name={w}
                                      proCode={t.winnersProCodes[index]}
                                      _id={t.winnersIds[index]}
                                      limitWidth='99%'
                                      limitMargin='1%'
                                    />
                                  </div>
                                ))}
                                <div
                                  className='col-12'
                                  style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    textAlign: 'center',
                                  }}
                                >
                                  {t.winners.map((w, index) => (
                                    <>
                                      <a
                                        href={'/user/' + t.winnersIds[index]}
                                        style={{
                                          marginRight: 5,
                                          marginLeft: 5,
                                        }}
                                      >
                                        {utils.nameTrim(w)}
                                      </a>
                                      {index !== t.winners.length - 1
                                        ? ' & '
                                        : ''}
                                    </>
                                  ))}
                                </div>
                              </div>
                            ) : (
                              ''
                            )}
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
            {/* End of Recent Trophys */}

            {/* Top 5 */}
            {this.renderAreaTitle({ title: 'Top 5' })}
            {this.renderAreaContents(
              <div className='row'>
                {this.state.homeInfo.tops.map((top) => {
                  return (
                    <div className='col-6 col-md-6 col-xl-3' key={top.key}>
                      <div className='card' style={{ borderWidth: 0 }}>
                        <div className='card-body' style={{ padding: '10px' }}>
                          {this.renderTopTitle(top.title)}
                          <div className='row'>
                            <div className='col-12'>
                              <AdvBasicTable
                                noHead
                                columns={[
                                  {
                                    key: 'uiName',
                                    leftAligned: true,
                                  },
                                  { key: top.key },
                                ]}
                                data={top.players.map((p) => ({
                                  ...p,
                                  uiName: <PlayerId {...p} />,
                                }))}
                              />
                            </div>{' '}
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
            {/* End of Top 5 */}

            {/* New Members */}
            {this.renderAreaTitle({ title: 'New Members' })}
            {this.renderAreaContents(
              <div className='row'>
                {utils.generateConsecutiveArray(4).map((n) => {
                  const m = this.state.homeInfo.newMembers[n - 1];
                  if (!m) return <div />;
                  return (
                    <div className='col-3' key={m._id}>
                      <div className='card' style={{ borderWidth: 0 }}>
                        <div className='card-body' style={{ padding: '10px' }}>
                          <div className='row'>
                            <div className='col-12'>
                              <img
                                src={'/api/file/avatar?proCode=' + m.proCode}
                                alt='profile'
                                style={{
                                  width: '40%',
                                  marginLeft: '30%',
                                  marginRight: '30%',
                                }}
                              />
                            </div>
                          </div>
                          <div className='row'>
                            <div
                              className='col-12'
                              style={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                textAlign: 'center',
                              }}
                            >
                              <a href={'/user/' + m._id}>{m.name}</a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
            {/* End of New Members */}

            {/* Partners and sponsors */}
            <div className='row'>
              {[
                {
                  title: 'Partners',
                  elements: this.state.homeInfo.partners,
                },
                {
                  space: true,
                },
                {
                  space: true,
                },
                {
                  space: true,
                },

                {
                  title: 'Sponsors',
                  elements: this.state.homeInfo.sponsors,
                },
              ].map((collection, i) =>
                collection.space ? (
                  <div className='col-3' key={i} />
                ) : collection.elements && collection.elements.length > 0 ? (
                  <div className='col-2' key={i}>
                    {this.renderAreaTitle({
                      title: collection.title,
                      large: true,
                    })}
                    {this.renderAreaContents(
                      <Slider
                        dots={false}
                        autoplay={true}
                        autoplaySpeed={2000}
                        infinite={true}
                        slidesToShow={1}
                        slidesToScroll={1}
                      >
                        {collection.elements.map((element) => (
                          <div key={element._id}>
                            <a
                              href={element.link}
                              target='_blank'
                              rel='noopener noreferrer'
                            >
                              <img
                                src={'/api/file/path?path=' + element.filepath}
                                alt='image'
                                style={{
                                  width: '80%',
                                  marginLeft: '10%',
                                  marginRight: '10%',
                                  marginTop: '5px',
                                }}
                              />
                            </a>
                          </div>
                        ))}
                      </Slider>
                    )}
                  </div>
                ) : (
                  <div className='col-2' key={i} />
                )
              )}
            </div>
            {/* End of Partners and Sponsors */}
            {this.context.user &&
              this.context.user.roles.includes('SuperAdmin') && (
                <div className='row'>
                  <div
                    className='col-12'
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      textAlign: 'center',
                      fontWeight: 'bold',
                    }}
                  >
                    <VisitorStatBox {...this.state.accessInfo} />
                  </div>
                </div>
              )}
          </>
        )}
      </div>
    );
  }
}
export default HomePage;
